import React, { Suspense, lazy } from 'react'
import Hero from './Hero'
import About from './About'
import Offers from './Offers'
import Freebeauty from './FreeBeauty'
import Categories from './Categories'
import Handicrafts from './Handicrafts'
import TissueBanner from './TissueBanner'
import ServicesBooklet from './ServicesBooklet'
import FeaturesArea from './FeaturesArea'
import ServicesBanner from './ServiceBanner'

const Testimonial = lazy(() => import('./Testimonial'))

const SubHome = () => {
  return (
    <div>
        <Hero/>
        {/* <About showAboutMainpg={true} /> */}
        <FeaturesArea/>
        <Offers/>
        {/* <ServicesBanner/> */}
        {/* <Freebeauty/> */}
        <Categories/>
        <ServicesBooklet/>
        <Handicrafts/>
        <TissueBanner/>
        <Suspense fallback={<div style={{minHeight: '400px'}} />}>
          <Testimonial/>
        </Suspense>
    </div>
  )
}

export default SubHome